import React, { useEffect, useState } from 'react';
import { fetchBookings, fetchStaffMembers, assignBookingToStaff, updateBookingNote } from '../../../../../../../Utilities/api/index.js';

function TaskAssignments() {
  const [bookings, setBookings] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchBookings(), fetchStaffMembers()])
      .then(([bookingsData, staffData]) => {
        // Optional: filter bookings to today
        const today = new Date().toISOString().split('T')[0];
        const todaysBookings = bookingsData.filter(b => b.startTime.startsWith(today));
        setBookings(todaysBookings);
        setStaff(staffData);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleAssign = async (bookingId, staffId) => {
    await assignBookingToStaff(bookingId, staffId);
    setBookings(prev =>
      prev.map(b => (b.id === bookingId ? { ...b, assignedTo: staffId } : b))
    );
  };

  const handleNoteChange = async (bookingId, note) => {
    await updateBookingNote(bookingId, note);
    setBookings(prev =>
      prev.map(b => (b.id === bookingId ? { ...b, specialNotes: note } : b))
    );
  };

  if (loading) return <div>Loading task assignments…</div>;

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Task Assignments</h2>
      {bookings.length === 0 && <p>No bookings today.</p>}
      {bookings.map(b => (
        <div key={b.id} style={{ border: '1px solid #ccc', padding: '1rem', marginBottom: '1rem' }}>
          <div><strong>Service:</strong> {b.bookingType}</div>
          <div><strong>Time:</strong> {new Date(b.startTime).toLocaleTimeString()}</div>

          <div>
            <label>Assign to:</label>
            <select
              value={b.assignedTo || ''}
              onChange={e => handleAssign(b.id, e.target.value)}
            >
              <option value="">-- Unassigned --</option>
              {staff.map(s => (
                <option key={s.id} value={s.id}>{s.username}</option>
              ))}
            </select>
          </div>

          <div>
            <label>Note:</label>
            <input
              type="text"
              value={b.specialNotes || ''}
              onChange={e => handleNoteChange(b.id, e.target.value)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default TaskAssignments;
